<script>
import ApiWst from './ApiWst'
import ApiOffline from './ApiOffline'
import ApiLocalStorage from './ApiLocalStorage'
import Vue from 'vue'
let defaultEngine = 'wst'
let engine = localStorage.getItem('hb3.engine')
if (!(engine && engine.length > 0)) {
  engine = defaultEngine
  localStorage.setItem('hb3.engine', engine)
}
let exportable
switch (engine) {
  case 'offline':
    exportable = ApiOffline
    break;
  case 'localStorage':
    exportable = ApiLocalStorage
    break;
  default:
    exportable = ApiWst
}
console.log("Api exportable?", engine)
export default exportable
</script>
